import React from 'react';
import ExcalmationSvg from './ExcalmationSvg';

const RemoveEmbedCodeMessage = () => (
  <span className="reactions-remove-embed-code-container">
    <ExcalmationSvg fill="#ff6f00" />
    <span className="reactions-remove-embed-code-text">
      <strong> Note: </strong> Please remove the previous embed code for updates to take effect.
    </span>
  </span>
);

export default RemoveEmbedCodeMessage;
